import {
  titleUI,
  checkboxGroupUI,
  checkboxGroupSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import AccruedBenefitsDescription from '../../../components/AccruedBenefitsDescription';
import { isRelationshipToVeteran } from '../../utils/helpers';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Benefit options'),
    claims: {
      ...checkboxGroupUI({
        required: true,
        labels: {
          dic: {
            title: content['benefit-type-dic-title'],
            description: content['benefit-type-dic-description'],
          },
          survivorsPension: {
            title: content['benefit-type-survivors-title'],
            description: content['benefit-type-survivors-description'],
          },
        },
      }),
      'ui:options': {
        tile: true,
        hint: 'This helps us prioritize the claim. We’ll still consider all benefits, but we may need more information depending on your choice.',
        updateSchema: formData => ({
          title:
            isRelationshipToVeteran(formData) === 'custodian'
              ? content['benefit-type-custodian-title']
              : content['benefit-type-updated-title'],
        }),
      },
    },
    'view:accruedBenefitsDescription': {
      'ui:description': AccruedBenefitsDescription,
    },
  },
  schema: {
    type: 'object',
    properties: {
      claims: checkboxGroupSchema(['dic', 'survivorsPension']),
      'view:accruedBenefitsDescription': {
        type: 'object',
        properties: {},
      },
    },
  },
};
